const user = {
  namespaced: true,
  state: {
    status: null,
    accessToken: null,
    fbAccessToken: null,
    userName: null,
    avatar: null,
    userID: null
  },
  getters: {
    getStatus: (state) => state.status,
    getAccessToken: (state) => state.accessToken,
    getFbAccessToken: (state) => state.fbAccessToken,
    getUserName: (state) => state.userName,
    getAvatar: (state) => state.avatar,
    getUserID: (state) => state.userID
  },
  mutations: {
    setStatus (state, status) {
      state.status = status
    },
    setAccessToken (state, accessToken) {
      state.accessToken = accessToken
    },
    setFbAccessToken (state, fbAccessToken) {
      state.fbAccessToken = fbAccessToken
    },
    setUserName (state, userName) {
      state.userName = userName
    },
    setAvatar (state, avatar) {
      state.avatar = avatar
    },
    setUserID (state, userID) {
      state.userID = userID
    }
  },
  actions: {
    setStatus ({ commit }, status) {
      commit('setStatus', status)
    },
    setAccessToken ({ commit }, accessToken) {
      commit('setAccessToken', accessToken)
    },
    setFbAccessToken ({ commit }, fbAccessToken) {
      commit('setFbAccessToken', fbAccessToken)
    },
    setUserName ({ commit }, userName) {
      commit('setUserName', userName)
    },
    setAvatar ({ commit }, avatar) {
      commit('setAvatar', avatar)
    },
    setUserID ({ commit }, userID) {
      commit('setUserID', userID)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/vuex/user.js